/* My Account → Order Status: an order's tabs (2026-10-16, Brett picked option C on the canvas
   https://claude.ai/artifact/CToJyMp3XuhCF5Tyqp7bgU). Overview · Documents · Proofs & Notes.
   sections/my-profile.liquid keeps the order list, the order header, the proof approval card, the
   slim pay bar, the step tracker and the Overview tab; this file draws:
   • Documents: what Zoho Books holds for the order (worker /apps/distributor/order-docs → sales
     order, invoices, credit notes, payments, and the money summary), with the selected document
     shown right in the tab (PDF from /apps/distributor/pdf). Too narrow for the side preview
     (container query on .cv-det) → a row opens the full-window viewer instead.
   • Proofs & Notes: the current proof (+ earlier versions) beside ONE timeline that interleaves the
     proof events (sent / approved / changes requested) with the order notes, then the note box.
   window.MPOrders(h) → api, h = helpers handed over by the section (see there). Plain ES5. */
(function () {
  'use strict';
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  // OMP dates are "Oct 3, 2026 2:15pm" in the site's time zone (notes AND proof events), so
  // comparing them as wall-clock values orders them right whatever the viewer's time zone.
  function wall(s) {
    var m = /^([A-Za-z]{3})[A-Za-z]*\.? (\d{1,2}), (\d{4})(?:,? (\d{1,2}):(\d{2}) ?([ap]m))?/i.exec(String(s || '').trim());
    if (!m) return null;
    var mo = MON.indexOf(m[1].charAt(0).toUpperCase() + m[1].slice(1, 3).toLowerCase());
    if (mo < 0) return null;
    var hr = m[4] ? (+m[4] % 12) + (/pm/i.test(m[6]) ? 12 : 0) : 0;
    return { t: Date.UTC(+m[3], mo, +m[2], hr, m[5] ? +m[5] : 0), y: +m[3], mo: mo, d: +m[2] };
  }
  function ymd(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(s || ''));
    return m ? { t: Date.UTC(+m[1], +m[2] - 1, +m[3]), y: +m[1], mo: +m[2] - 1, d: +m[3] } : null;
  }
  function short(w) {
    if (!w) return '';
    var s = MON[w.mo] + ' ' + w.d;
    return w.y !== new Date().getFullYear() ? s + ', ' + w.y : s;
  }
  function payMode(m) {
    var s = String(m || '');
    if (/authorize|card|stripe|paypal|square|visa|master|amex/i.test(s)) return 'Card payment';
    if (/ach|bank|wire|transfer|eft/i.test(s)) return 'Bank transfer';
    if (/check|cheque/i.test(s)) return 'Check';
    return s || 'Payment';
  }
  var KIND = { salesorder: ['Sales order', 'SO'], invoice: ['Invoice', 'INV'], creditnote: ['Credit note', 'CN'], payment: ['Payment', 'PAY'] };

  window.MPOrders = function (h) {
    var docs = {};   // order id → { st: 'loading'|'ok'|'err', d, busy, stale, sel }
    var pdfs = {};   // 'kind:id' → { st: 'loading'|'ok'|'err', url }
    function ro() { return !!(h.ro && h.ro()); }
    function money(n) { return h.money(n); }

    // ── data ────────────────────────────────────────────────────────────────
    function invNums(o) {
      var out = [];
      var add = function (v) { v = String(v || '').trim(); if (v && out.indexOf(v) === -1 && out.length < 8) out.push(v); };
      add(o.invoice_number);
      (o.shipping_addresses || []).forEach(function (a) { add(a && a.invoice); });
      (o.invoices_due || []).forEach(function (i) { add(i.number); });
      return out;
    }
    function ckey(o) { return h.swrKey ? h.swrKey('odocs:' + o.id) : null; }
    function ensureDocs(o, fresh) {
      if (!o) return;
      var id = String(o.id), e = docs[id];
      if (!e) {
        var c = h.swrGet ? h.swrGet(ckey(o)) : null;
        e = docs[id] = c ? { st: 'ok', d: c, stale: true } : { st: 'loading' };
      }
      if (e.busy || (e.st === 'ok' && !e.stale && !fresh && !e.fresh)) return;
      var useFresh = !!(fresh || e.fresh);
      e.busy = true; e.fresh = false;
      if (!e.d) e.st = 'loading';
      var url = '/apps/distributor/order-docs?so=' + encodeURIComponent(o.sales_order_number || '') + '&inv=' + encodeURIComponent(invNums(o).join(','))
        + (useFresh ? '&fresh=1' : '') + '&t=' + Date.now() + (h.sfx ? h.sfx() : '');
      fetch(url, { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (docs[id] !== e) return;   // reset meanwhile (account switch)
          e.busy = false;
          if (d && d.status === 'ok') {
            e.d = d; e.st = 'ok'; e.stale = false;
            if (!d.partial && h.swrPut) h.swrPut(ckey(o), d);
          } else if (!e.d) { e.st = 'err'; }
          if (h.onDocs) h.onDocs(id);
        })
        .catch(function () {
          if (docs[id] !== e) return;
          e.busy = false;
          if (!e.d) e.st = 'err';
          if (h.onDocs) h.onDocs(id);
        });
    }
    function chipFor(kind, x) {
      if (kind === 'salesorder') {
        var s = String(x.status || '').toLowerCase();
        return s === 'void' ? { k: 'proc', t: 'Void' } : s === 'closed' ? { k: 'info', t: 'Closed' } : { k: 'info', t: 'Confirmed' };
      }
      if (kind === 'invoice') {
        if (!(Number(x.balance) > 0.004)) return { k: 'ok', t: 'Paid' };
        if (x.processing) return { k: 'proc', t: 'Payment processing' };
        if (h.invOver && h.invOver(x)) return { k: 'over', t: 'Overdue' };
        var due = ymd(x.due_date);
        var part = Number(x.total) > Number(x.balance) + 0.004;
        return { k: 'due', t: (part ? 'Partly paid · ' : '') + (due ? 'Due ' + short(due) : 'Balance due') };
      }
      if (kind === 'creditnote') return Number(x.left) > 0.004 ? { k: 'ok', t: money(x.left) + ' left to use' } : { k: 'ok', t: 'Applied' };
      return { k: 'pay', t: 'Received' };
    }
    function items(d) {
      var out = [];
      if (!d) return out;
      if (d.so) out.push({ kind: 'salesorder', id: d.so.id, num: d.so.number, date: d.so.date, amt: money(d.so.total), chip: chipFor('salesorder', d.so), x: d.so });
      (d.invoices || []).forEach(function (i) { out.push({ kind: 'invoice', id: i.id, num: i.number, date: i.date, amt: money(i.total), chip: chipFor('invoice', i), x: i }); });
      (d.credits || []).forEach(function (c) { out.push({ kind: 'creditnote', id: c.id, num: c.number, date: c.date, amt: '−' + money(c.amount), neg: true, sub: c.invoices && c.invoices.length ? 'Applied to ' + c.invoices.join(', ') : '', chip: chipFor('creditnote', c), x: c }); });
      (d.payments || []).forEach(function (p) { out.push({ kind: 'payment', id: p.id, num: p.number, title: payMode(p.mode), date: p.date, amt: money(p.amount), sub: p.invoices && p.invoices.length ? 'Toward ' + p.invoices.join(', ') : '', chip: chipFor('payment', p), x: p }); });
      return out;
    }
    function count(o) { var e = o && docs[String(o.id)]; return e && e.d ? items(e.d).length : null; }
    function selKey(o, list) {
      var e = docs[String(o.id)], k = e && e.sel;
      for (var i = 0; i < list.length; i++) { if (list[i].kind + ':' + list[i].id === k) return k; }
      return list.length ? list[0].kind + ':' + list[0].id : '';
    }

    // ── tabs ────────────────────────────────────────────────────────────────
    function defaultTab(o, unread) { return (o && (o.approval_url || unread > 0)) ? 'pn' : 'overview'; }
    // Card-style tabs (2026-10-19, Brett: make them stand out so distributors know to switch screens):
    // an icon, the name and a one-line hint of what's inside; the open one is raised. On phones the
    // hint hides and the three share one row.
    var TAB_IC = {
      overview: '<path d="M4 5h16v14H4z"/><path d="M4 10h16"/><path d="M10 10v9"/>',
      docs: '<path d="M7 3h7l5 5v13H7z"/><path d="M14 3v5h5"/><path d="M10 13h6"/><path d="M10 17h6"/>',
      pn: '<path d="M4 5h16v11H9l-5 4z"/><path d="M8 9.5h8"/><path d="M8 12.5h5"/>'
    };
    function tabsHtml(o, tab, unread) {
      var n = count(o), notes = (o.notes || []).length;
      var trk = !!((o.tracking && o.tracking.length) || o.tracking_number);
      var t = function (k, label, hint, badge) {
        var on = tab === k;
        return '<button type="button" role="tab" class="cv-tab' + (on ? ' is-on' : '') + '" id="cv-tab-' + k + '" data-cv-tab="' + k + '" aria-selected="' + (on ? 'true' : 'false') + '" aria-controls="cv-tabpanel" tabindex="' + (on ? '0' : '-1') + '">'
          + '<span class="cv-tab__ic" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' + TAB_IC[k] + '</svg></span>'
          + '<span class="cv-tab__tx"><span class="cv-tab__row"><span class="cv-tab__l">' + label + '</span>' + badge + '</span><span class="cv-tab__hint">' + hint + '</span></span></button>';
      };
      return '<div class="cv-tabs" role="tablist" aria-label="Order details">'
        + t('overview', 'Overview', trk ? 'Details &amp; tracking' : 'Order details', '')
        + t('docs', 'Documents', 'Invoices &amp; payments', '<span class="cv-tab__n" id="cv-tab-docs-n"' + (n ? '' : ' hidden') + '>' + (n || '') + '</span>')
        + t('pn', 'Proofs &amp; Notes', 'Proof &amp; messages', unread > 0 ? '<span class="cv-tab__n is-new">' + unread + ' new</span>' : (notes ? '<span class="cv-tab__n">' + notes + '</span>' : ''))
        + '</div>';
    }
    function badge(o) {
      var el = document.getElementById('cv-tab-docs-n'), n = count(o);
      if (!el) return;
      el.textContent = n || ''; el.hidden = !n;
    }

    // ── Documents tab ───────────────────────────────────────────────────────
    function payLink(i, label, cls) {
      if (!i.pay_url || i.processing || !(Number(i.balance) > 0.004)) return '';
      var inner = '<i class="fa-solid fa-credit-card" aria-hidden="true"></i> ' + esc(label);
      return ro()
        ? '<span class="cv-paybtn ' + (cls || '') + ' is-preview" aria-disabled="true" title="Customers see this button. It’s turned off in Staff View.">' + inner + '</span>'
        : '<a class="cv-paybtn ' + (cls || '') + '" href="' + esc(i.pay_url) + '" target="_blank" rel="noopener" data-cv-pay="' + esc(i.number) + '">' + inner + '</a>';
    }
    function docsHtml(o) {
      var e = docs[String(o.id)];
      if (!e || (!e.d && e.st !== 'err')) return '<div class="cvd-msg"><i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i> Loading the documents for this order…</div>';
      if (!e.d) return '<div class="cvd-msg cvd-msg--err">We couldn’t load the documents just now. <button type="button" class="cvd-retry" data-cv-docs-retry="1"><i class="fa-solid fa-rotate-right" aria-hidden="true"></i> Try again</button></div>';
      var d = e.d, list = items(d);
      if (!list.length) return '<div class="cvd-msg">No documents yet. The sales order shows up here once the order is in our system, and invoices once it’s billed.</div>';
      var sel = selKey(o, list), cur = null;
      var rows = list.map(function (x) {
        var key = x.kind + ':' + x.id, on = key === sel;
        if (on) cur = x;
        var w = ymd(x.date);
        var sub = (w ? short(w) + ' · ' : '') + '<span class="cvd-doc__amt' + (x.neg ? ' is-neg' : '') + '">' + esc(x.amt) + '</span>' + (x.sub ? '<span class="cvd-doc__sub">' + esc(x.sub) + '</span>' : '');
        var payUrl = x.kind === 'invoice' && !ro() && x.x.pay_url && Number(x.x.balance) > 0.004 && !x.x.processing ? x.x.pay_url : '';
        return '<button type="button" class="cvd-doc cvd-doc--' + x.kind + (on ? ' is-on' : '') + '" data-cv-doc="' + esc(key) + '" data-name="' + esc(x.num) + '"' + (payUrl ? ' data-pay="' + esc(payUrl) + '"' : '') + ' aria-pressed="' + (on ? 'true' : 'false') + '">'
          + '<span class="cvd-doc__ic" aria-hidden="true">' + KIND[x.kind][1] + '</span>'
          + '<span class="cvd-doc__main"><span class="cvd-doc__k">' + KIND[x.kind][0] + '</span><span class="cvd-doc__n">' + esc(x.title || x.num) + '</span><span class="cvd-doc__s">' + sub + '</span></span>'
          + '<span class="cvd-chip cvd-chip--' + x.chip.k + '">' + esc(x.chip.t) + '</span></button>';
      }).join('');
      var t = d.totals || {}, bal = '';
      if ((d.invoices || []).length) {
        var r = function (label, v, cls) { return '<div class="cvd-bal__r' + (cls ? ' ' + cls : '') + '"><span>' + label + '</span><b>' + v + '</b></div>'; };
        bal = '<div class="cvd-bal">' + r('Invoiced', esc(money(t.invoiced)))
          + (t.credits > 0 ? r('Credits', '−' + esc(money(t.credits)), 'is-neg') : '')
          + (t.payments > 0 ? r('Payments', '−' + esc(money(t.payments))) : '')
          + (t.writeoff > 0 ? r('Written off', '−' + esc(money(t.writeoff))) : '')
          + r('Balance due', esc(money(t.balance)), 'cvd-bal__tot')
          + (t.balance <= 0.004 ? '<span class="cvd-chip cvd-chip--ok cvd-bal__paid"><i class="fa-solid fa-circle-check" aria-hidden="true"></i> Paid in full</span>' : '')
          + (d.invoices || []).map(function (i) { return payLink(i, 'Pay ' + i.number, 'cv-paybtn--sm'); }).join('')
          + '</div>';
      }
      var partial = d.partial ? '<div class="cvd-msg cvd-msg--err">Some documents couldn’t load. <button type="button" class="cvd-retry" data-cv-docs-retry="1"><i class="fa-solid fa-rotate-right" aria-hidden="true"></i> Try again</button></div>' : '';
      var label = KIND[cur.kind][0] + (cur.kind === 'payment' ? ' receipt' : '') + ' ' + cur.num;
      var pay = cur.kind === 'invoice' && !ro() && cur.x.pay_url && Number(cur.x.balance) > 0.004 && !cur.x.processing ? cur.x.pay_url : '';
      var prev = '<div class="cvd-prev" data-doc="' + esc(sel) + '" data-kind="' + cur.kind + '" data-id="' + esc(cur.id) + '" data-name="' + esc(cur.num) + '">'
        + '<div class="cvd-prev__bar"><span class="cvd-prev__t"><i class="fa-solid fa-file-pdf" aria-hidden="true"></i> ' + esc(label) + '</span>'
        + '<a class="cvd-btn cvd-btn--pri" data-cvd-dl="1" href="#" aria-disabled="true"><i class="fa-solid fa-download" aria-hidden="true"></i> Download PDF</a>'
        + '<button type="button" class="cvd-btn" data-cvd-print="1" disabled aria-label="Print"><i class="fa-solid fa-print" aria-hidden="true"></i></button>'
        + '<a class="cvd-btn mp-pdf-link" href="#" data-pdf-type="' + cur.kind + '" data-pdf-id="' + esc(cur.id) + '" data-pdf-name="' + esc(cur.num) + '"' + (pay ? ' data-pdf-pay="' + esc(pay) + '"' : '') + ' aria-label="Open full size" title="Open full size"><i class="fa-solid fa-magnifying-glass-plus" aria-hidden="true"></i></a></div>'
        + '<div class="cvd-prev__body"><div class="cvd-prev__st"><i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i> Loading ' + esc(label) + '…</div><iframe class="cvd-prev__f" title="' + esc(label) + '"></iframe></div></div>';
      return partial + '<div class="cvd"><div class="cvd-side">' + rows + bal + '</div>' + prev + '</div>';
    }
    function previewShown(root) {
      var p = (root || document).querySelector('.cvd-prev');
      return !!(p && p.offsetParent !== null);
    }
    function select(orderId, key) { var e = docs[String(orderId)]; if (e) e.sel = key; }
    function zoomFor(f) {
      var w = (f && f.clientWidth) || 600, fit = (w - 40) / 816;
      return Math.max(30, Math.min(100, Math.round(fit * 100)));
    }
    function mountPreview(root) {
      var p = (root || document).querySelector('.cvd-prev');
      if (!p || p.offsetParent === null) return;   // hidden (narrow) → rows open the full viewer instead
      var key = p.getAttribute('data-doc'), kind = p.getAttribute('data-kind'), id = p.getAttribute('data-id'), name = p.getAttribute('data-name');
      var st = p.querySelector('.cvd-prev__st'), f = p.querySelector('.cvd-prev__f');
      var dl = p.querySelector('[data-cvd-dl]'), pr = p.querySelector('[data-cvd-print]');
      var x = pdfs[key];
      if (x && x.st === 'ok') {
        dl.href = x.url; dl.setAttribute('download', h.fileName ? h.fileName(kind, name, id) : (name + '.pdf')); dl.removeAttribute('aria-disabled');
        pr.disabled = false;
        pr.onclick = function () { try { f.contentWindow.focus(); f.contentWindow.print(); } catch (err) { window.open(x.url, '_blank'); } };
        if (navigator.pdfViewerEnabled === false) {
          st.innerHTML = 'This browser can’t show PDFs inside the page. Use Download PDF above.';
          return;
        }
        st.hidden = true;
        f.style.visibility = 'visible';   // never display:none while loading (Chrome sizes its PDF viewer on load)
        f.src = x.url + '#zoom=' + zoomFor(f) + '&navpanes=0&toolbar=0';
        return;
      }
      if (x && x.st === 'err') {
        st.className = 'cvd-prev__st is-err';
        st.innerHTML = '<span><i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i> This document couldn’t be loaded. <button type="button" class="cvd-retry" data-cvd-pdf-retry="' + esc(key) + '">Try again</button></span>';
        return;
      }
      if (x && x.st === 'loading') return;
      pdfs[key] = { st: 'loading' };
      fetch('/apps/distributor/pdf?type=' + encodeURIComponent(kind) + '&id=' + encodeURIComponent(id) + '&t=' + Date.now() + (h.sfx ? h.sfx() : ''), { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          if (!j || !j.ok || !j.data) throw new Error('no-pdf');
          var bin = atob(j.data), len = bin.length, arr = new Uint8Array(len);
          for (var i = 0; i < len; i++) arr[i] = bin.charCodeAt(i);
          pdfs[key] = { st: 'ok', url: URL.createObjectURL(new Blob([arr], { type: 'application/pdf' })) };
        })
        .catch(function () { pdfs[key] = { st: 'err' }; })
        .then(function () {
          var again = document.querySelector('.cvd-prev[data-doc="' + key.replace(/"/g, '') + '"]');
          if (again) mountPreview(again.parentNode);
        });
    }
    function retryPdf(key) { delete pdfs[key]; }
    function invalidate() { Object.keys(docs).forEach(function (k) { if (docs[k]) docs[k].fresh = true; }); }
    function reset() {
      docs = {};
      Object.keys(pdfs).forEach(function (k) { if (pdfs[k] && pdfs[k].url) { try { URL.revokeObjectURL(pdfs[k].url); } catch (e) {} } });
      pdfs = {};
    }

    // ── Proofs & Notes tab ──────────────────────────────────────────────────
    function timeline(o, newSince) {
      var hist = o.proof_history; if (hist && !Array.isArray(hist)) hist = [hist]; hist = hist || [];
      var ev = [], seq = 0, lastT = 0;
      var push = function (t, x) { if (t == null) t = lastT; lastT = Math.max(lastT, t); x.t = t; x.i = seq++; ev.push(x); };
      var od = ymd(o.order_date);
      if (od) push(od.t, { k: 'ev', cls: '', txt: 'Order placed', w: od });
      hist.forEach(function (x, i) {
        var v = 'V' + (x.version || i + 1), st = String(x.status || '').toLowerCase(), last = i === hist.length - 1;
        var ws = wall(x.sent), wr = wall(x.responded) || ws;
        var waiting = st === 'pending' && last;
        push(ws ? ws.t : null, { k: 'ev', cls: waiting ? 'wait' : 'proof', txt: 'Proof ' + v + ' sent' + (waiting ? (ro() ? ' · waiting on the customer' : ' · waiting on you') : ''), w: ws });
        if (st === 'approved') push(wr ? wr.t : null, { k: 'ev', cls: 'ok', txt: 'Proof ' + v + ' approved' + (x.approved_by ? ' by ' + x.approved_by : ''), w: wr });
        else if (st && st !== 'pending') {
          if (x.reason) push(wr ? wr.t : null, { k: 'you', tag: 'Change request · ' + v, txt: x.reason, w: wr });
          else push(wr ? wr.t : null, { k: 'ev', cls: 'chg', txt: 'Changes requested on proof ' + v, w: wr });
        }
      });
      (o.notes || []).forEach(function (n) {
        var w = wall(n.date), mine = h.isMine ? h.isMine(n) : false;
        push(w ? w.t : null, { k: mine ? 'you' : 'rep', who: mine ? 'You' : (String(n.author || '').trim() || 'IDProductsource'), txt: n.text || '', w: w, isNew: !mine && newSince != null && (n.ts || 0) > newSince });
      });
      ev.sort(function (a, b) { return (a.t - b.t) || (a.i - b.i); });
      return ev;
    }
    function pnHtml(o, opt) {
      opt = opt || {};
      var hist = o.proof_history; if (hist && !Array.isArray(hist)) hist = [hist]; hist = hist || [];
      var proofs = o.proofs || [], last = hist.length ? hist[hist.length - 1] : null;
      var lst = last ? String(last.status || '').toLowerCase() : '';
      var col;
      if (proofs.length || hist.length) {
        var chip = !last ? '' : lst === 'pending' ? '<span class="cvp-chip cvp-chip--wait">' + (ro() ? 'Waiting on the customer' : 'Waiting on you') + '</span>'
          : lst === 'approved' ? '<span class="cvp-chip cvp-chip--ok">Approved</span>' : '<span class="cvp-chip cvp-chip--chg">Changes requested</span>';
        var thumbs = proofs.length ? '<div class="cvp-thumbs' + (proofs.length === 1 ? ' is-one' : '') + '">' + proofs.map(function (p) {
          var pt = p.type === 'pdf' ? 'pdf' : 'image';
          return '<a class="mp-proof" href="#" data-proof="' + esc(p.url) + '" data-proof-type="' + pt + '" title="View proof full size">'
            + (p.thumb ? '<img src="' + esc(p.thumb) + '" alt="Proof" loading="lazy">' : '<i class="fa-solid ' + (pt === 'pdf' ? 'fa-file-pdf' : 'fa-file') + '" aria-hidden="true"></i>')
            + (pt === 'pdf' ? '<span class="cv-proof__pdf">PDF</span>' : '') + '</a>';
        }).join('') + '</div>' : '';
        var sent = last && wall(last.sent);
        col = '<div class="cvp-cur' + (lst === 'pending' ? ' is-wait' : '') + '"><div class="cvp-cur__hd"><b>' + (last ? 'Proof V' + esc(last.version || hist.length) : 'Proof') + '</b>' + chip + '</div>'
          + thumbs + (sent ? '<span class="cvp-cur__s">Sent ' + short(sent) + (proofs.length ? ' · click to see it full size' : '') + '</span>' : '') + '</div>';
        var older = hist.slice(0, -1).reverse();
        if (older.length) {
          col += '<div class="cvp-old"><span class="cvp-old__h">Earlier versions</span>' + older.map(function (x, i) {
            var s = String(x.status || '').toLowerCase(), w = wall(x.responded) || wall(x.sent);
            var lbl = s === 'approved' ? 'Approved' : s === 'pending' ? 'Not answered' : 'Changes requested';
            return '<div class="cvp-old__r"><b>V' + esc(x.version || (older.length - i)) + '</b><span>' + lbl + (w ? ' · ' + short(w) : '') + '</span></div>';
          }).join('') + '</div>';
        }
      } else {
        col = '<div class="cvp-cur cvp-cur--none"><b>Proofs</b><span class="cvp-cur__s">No proof yet. It shows up here as soon as your rep sends it.</span></div>';
      }
      var ev = timeline(o, opt.newSince);
      var hasTalk = ev.some(function (x) { return x.k !== 'ev' || x.txt !== 'Order placed'; });
      var tl = ev.map(function (x) {
        var when = short(x.w);
        if (x.k === 'ev') return '<div class="cvp-ev' + (x.cls ? ' cvp-ev--' + x.cls : '') + '"><span>' + esc(x.txt) + (when ? ' · ' + when : '') + '</span></div>';
        var who = x.k === 'you' ? 'You' : x.who;
        return '<div class="cvn-msg cvn-msg--' + x.k + (x.isNew ? ' is-new' : '') + '"><span class="cvn-msg__who">' + esc(who)
          + (x.tag ? ' <span class="cvn-msg__tag">' + esc(x.tag) + '</span>' : '') + (x.isNew ? ' <span class="cvn-msg__new">New</span>' : '') + '</span>'
          + esc(x.txt) + (when ? '<span class="cvn-msg__ts">' + when + '</span>' : '') + '</div>';
      }).join('');
      return '<div class="cvp"><div class="cvp-col">' + col + '</div>'
        + '<div class="cvp-feed"><div class="cvp-feed__hd"><b>Activity &amp; notes</b><span>Proof updates and messages with your rep, newest at the bottom.</span></div>'
        + '<div class="cvp-tl">' + tl + '</div>'
        + (hasTalk ? '' : '<div class="cvn-none">No notes on this order yet. Ask a question or post an update below and your rep will see it right away.</div>')
        + (opt.composer || '') + '</div></div>';
    }

    return {
      defaultTab: defaultTab, tabsHtml: tabsHtml, badge: badge, count: count,
      ensureDocs: ensureDocs, docsHtml: docsHtml, items: items, select: select, previewShown: previewShown,
      mountPreview: mountPreview, retryPdf: retryPdf, invalidate: invalidate, reset: reset,
      pnHtml: pnHtml, timeline: timeline, wall: wall, invNums: invNums
    };
  };
})();
